import React, { useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import WizardDataContext from '../store/WizardDataContext';
import { promotePendingToPaid } from '../utils/paymentLock';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const wizardCtx = useContext(WizardDataContext);

  const paymentId = searchParams.get('payment_id');
  const status = searchParams.get('status');
  const term = searchParams.get('term') || 'short-term';
  const isRenewal = searchParams.get('type') === 'renew';

  useEffect(() => {
    // Clear wizard data and affiliate code after successful payment so next coupon starts fresh
    if (status === 'success' || paymentId) {
      // Lock the just-paid entry so Back/bfcache into the wizard can't edit it.
      promotePendingToPaid();
      wizardCtx.clearAllData();
      try {
        localStorage.removeItem('deliva_affiliate_code');
      } catch (e) {
        console.warn('Could not clear affiliate on payment success', e);
      }
    }
  }, [status, paymentId, wizardCtx]);

  const handleGoHome = () => {
    navigate('/', { replace: true });
  };

  const handleCreateAnother = () => {
    wizardCtx.clearAllData();
    try {
      localStorage.removeItem('deliva_affiliate_code');
    } catch (e) {
      // ignore
    }
    navigate(`/advertise/coupon/${term}/create-coupon/1?edit=false`, { replace: true });
  };

  if (status === 'processing') {
    return (
      <div className="payment-processing-container">
        <div className="payment-processing-content">
          <CircularProgress size={60} style={{ color: 'white', marginBottom: '20px' }} />
          <h1>Processing Your Payment</h1>
          <p>Please wait while we process your payment and create your coupon...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-success-container">
      <div className="payment-success-content">
        {/* Checkmark Icon */}
        <div className="payment-success-checkmark">
          <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </div>

        {/* Main Title */}
        <h1 className="payment-success-title">
          Thanks
        </h1>

        {/* Success Message */}
        <p className="payment-success-message">
          The payment has been completed successfully!
        </p>

        {/* Separator Line */}
        <div className="payment-success-separator" />

        {/* Review Message */}
        <p className="payment-success-review">
          {isRenewal
            ? 'Your new claims will be added to your live Pop-in as soon as PayFast confirms the payment.'
            : 'Your coupon will be reviewed and approved within 24 to 48 hours.'}
        </p>

        {/* Action Buttons */}
        <div className="payment-success-actions">
          <button
            onClick={handleCreateAnother}
            className="payment-success-btn-primary"
          >
            CREATE ANOTHER DEAL
          </button>
          <button
            onClick={handleGoHome}
            className="payment-success-btn-secondary"
          >
            GO TO HOME
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
